import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { socketService } from '../services/socketService';

const { FiZap, FiX, FiActivity } = FiIcons;

const ActivityFeed = () => {
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    // Listen for global site activity from the socket service
    const handleGlobalActivity = (activity) => {
      const id = activity.id || Date.now();
      
      setActivities(prev => {
        // Prevent duplicates
        if (prev.some(a => a.id === id)) return prev;
        
        // Keep only top 3 activities
        const newActivities = [{ ...activity, id }, ...prev].slice(0, 3);
        return newActivities;
      });
      
      // Auto-remove after 5 seconds
      setTimeout(() => {
        setActivities(prev => prev.filter(a => a.id !== id));
      }, 5000);
    };

    // Use the global channel proxy
    const globalChannel = socketService.getGlobalChannel();
    globalChannel.on('site_activity', handleGlobalActivity);

    return () => {
      globalChannel.off('site_activity', handleGlobalActivity);
    };
  }, []);

  return (
    <div className="fixed bottom-6 left-6 z-50 pointer-events-none flex flex-col gap-3">
      <AnimatePresence initial={false}>
        {activities.map((activity) => (
          <motion.div
            key={activity.id}
            initial={{ opacity: 0, x: -50, scale: 0.8 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: -20, scale: 0.9, transition: { duration: 0.2 } }}
            className="pointer-events-auto bg-white/95 backdrop-blur-md border border-primary-100 shadow-xl rounded-2xl p-4 flex items-center gap-4 min-w-[280px] max-w-[320px]"
          >
            <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${
              activity.type === 'create' ? 'bg-primary-100 text-primary-600' : 'bg-green-100 text-green-600'
            }`}>
              <SafeIcon icon={activity.type === 'create' ? FiZap : FiActivity} className="w-5 h-5" />
            </div>
            
            <div className="flex-1">
              <p className="text-sm font-bold text-gray-900 leading-tight">
                Someone from <span className="text-primary-600">{activity.location}</span>
              </p>
              <p className="text-xs text-gray-500 mt-0.5 font-medium">
                {activity.type === 'create' ? 'just created a room' : 'just shared a clip'}
              </p>
            </div>

            <button 
              onClick={() => setActivities(prev => prev.filter(a => a.id !== activity.id))}
              className="text-gray-400 hover:text-gray-600 transition-colors p-1"
            >
              <SafeIcon icon={FiX} className="w-3.5 h-3.5" />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default ActivityFeed;